
<div>
	<div class="pt-0 pl-3 pr-0 ml-0 ml-0 locum-view-card">
		<v-row no-gutters class="pb-3">
			<v-col>
				<v-card class="elevation-1 justify-center text-center" color="white">
					<v-row v-if="(!locumData && !locumFromStore.booking) || loading" justify="center">
						<v-col cols="1" class="mt-8 mb-8">
							<v-progress-circular indeterminate></v-progress-circular>
						</v-col>
					</v-row>
					<v-row v-if="showLocumSection && hasLocum && locumData && !loading">
						<v-col :cols="6" :lg="6">
							<v-row v-if="!locumPreviewId">
								<v-col>
									<div>
										<v-btn class="v-btn v-btn--text theme--light v-size--default secondary--text" style="float: left" text @click="cancelLocumSearch()"
											><v-icon left large color="secondary">mdi-chevron-left</v-icon>Back</v-btn
										>
									</div>
								</v-col>
							</v-row>

							<div>
								<v-hover>
									<v-list-item-avatar
										slot-scope="{ hover }"
										:class="{ 'elevation-10': hover }"
										:size="$vuetify.breakpoint.smAndDown ? 110 : 140"
										align="center"
										justify="center"
									>
										<v-skeleton-loader
											v-if="!locumImage"
											type="image"
											:loading="true"
											:width="$vuetify.breakpoint.smAndDown ? 110 : 140"
											:height="$vuetify.breakpoint.smAndDown ? 110 : 140"
											align="center"
											justify="center"
										>
										</v-skeleton-loader>
										<template v-if="locumImage">
											<v-img id="professional-avatar" :src="locumImage" @click="avatarModel = true"></v-img>
										</template>
									</v-list-item-avatar>
								</v-hover>
							</div>

							<v-container align="center" justify="center" class="pa-5 pb-0">
								<v-dialog v-model="avatarModel" width="500">
									<v-card>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn color="primary" text @click="avatarModel = false"> Close </v-btn>
										</v-card-actions>
										<v-container align="center" justify="center">
											<v-img :src="locumImage"></v-img>
										</v-container>
									</v-card>
								</v-dialog>
							</v-container>

							<div align="left" class="pl-2 mt-3">
								<div v-for="detail in locumLocationDetails" :key="detail.name">
									<small v-if="detail.name && detail.value" class="mt-1">
										<strong>{{ detail.name }}:</strong>
										{{ detail.value }}
									</small>
								</div>
							</div>

							<div class="black-text font-weight-black mt-4 pl-2" align="left">Short Bio</div>

							<div v-if="locum.short_bio" class="pr-1 text-left pl-2">
								<small>{{ locum.short_bio }}</small>
							</div>

							<div
								v-if="
									(viewSource !== 'locumDirectory' && viewSource === 'viewUpcomingBooking') ||
									(viewSource !== 'locumDirectory' && viewSource === 'viewBookingRequestSent')
								"
								class="pr-1 text-left pl-2"
							>
								<v-btn class="white--text button-rounded mt-2" :height="25" width="100%" color="green" @click="BookAgain()"
									><span style="font-size: 10px">Book Again</span></v-btn
								>
							</div>

							<div v-if="viewSource === 'quickBookOption'" class="mt-4 pl-1 pr-1" width="90%">
								<v-row>
									<v-col class="justify-center text-center">
										<v-btn-toggle v-model="calendarInputMode" mandatory>
											<v-btn
												rounded
												small
												:color="calendarInputMode == 0 ? 'primary' : '#FFF'"
												:class="[calendarInputMode == 0 ? 'white--text' : 'primary--text text--darken-2']"
												style="
													border-radius: 20px 0px 0px 20px;
													font-family: Montserrat;
													font-style: normal;
													font-weight: bold;
													font-size: 10px;
													line-height: 15px;
													text-align: center;
												"
											>
												Date range
											</v-btn>

											<v-btn
												rounded
												small
												:color="calendarInputMode == 1 ? 'primary' : '#FFF'"
												:class="[calendarInputMode == 1 ? 'white--text' : 'primary--text text--darken-2']"
												style="
													border-radius: 0px 20px 20px 0px;
													font-family: Montserrat;
													font-style: normal;
													font-weight: bold;
													font-size: 10px;
													line-height: 15px;
													text-align: center;
												"
											>
												Specific days
											</v-btn>
										</v-btn-toggle>
									</v-col>
								</v-row>
								<v-date-picker
									v-model="selectedDates"
									:min="new Date().toISOString().substr(0, 10)"
									header-color="primary"
									color="primary"
									full-width
									no-title
									:multiple="calendarInputMode == 1"
									:range="calendarInputMode == 0"
									class="elevation-0"
								></v-date-picker>

								<v-btn :class="[contrastOnPrimary, 'button-rounded', 'mt-2']" :height="25" width="80%" color="primary" @click="() => {}"
									><span style="font-size: 10px">Quick Book</span></v-btn
								>
							</div>
						</v-col>
						<v-col :cols="6" :lg="6" class="text-left">
							<div class="title black--text font-weight-black mt-2">{{ locum.first_name }} {{ locum.last_name }}</div>
							<div class="blue--text lighten-1 font-weight-black">{{ locum.profession }}</div>

							<div align="left" class="mt-3">
								<div v-for="detail in locumDetails" :key="detail.name">
									<small v-if="detail.name && detail.value" class="mt-1">
										<strong>{{ detail.name }}:</strong>
										{{ detail.value }}
									</small>
								</div>
							</div>

							<div v-if="locum.skills && locum.skills.length > 0" class="mt-3">
								<div class="black-text font-weight-black mt-4">{{ getLabel('additionalSkills', 'Skills & Courses') }}</div>
								<div v-for="code in locum.skills" :key="code" :v-if="industryKeys[code]">
									<small>{{ industryKeys[code] }}</small>
								</div>
							</div>

							<locum-work-experience
								v-if="
									locum.experience.companies_worked_for &&
									[
										'calendarDashboardSearchExact',
										'calendarDashboardSearchPartial',
										'viewLocumApplication',
										'viewUpcomingBooking',
										'viewBookingRequestSent',
										'viewPostedOffer',
										'viewHistoricalBooking',
										'locumDirectory',
										'previewLocumProfile',
									].includes(viewSource)
								"
								:companies="locum.experience.companies_worked_for"
								class="mt-4"
							></locum-work-experience>

							<div v-if="locumRates.length === 3" class="mt-3">
								<div class="black-text font-weight-black mt-4">Hourly Rates</div>
								<div v-for="rate in locumRates" :key="rate.label">
									<small>{{ rate.label }}: {{ rate.value }}</small>
								</div>
							</div>

							<div class="mt-5">
								<v-row align="center" justify="center">
									<v-col cols="12" sm="12" md="12">
										<v-btn
											v-if="viewSource.includes('calendarDashboardSearch')"
											class="white--text button-rounded mt-2"
											:height="25"
											width="80%"
											color="primary"
											@click="sendBookingRequest()"
											><span style="font-size: 10px">{{ getLabel('bookingFlowSendBookingRequest', 'Send Booking Request') }}</span></v-btn
										>
									</v-col>
								</v-row>
							</div>
						</v-col>
					</v-row>

					<hr v-if="showLocumSection && locumFromStore.booking" style="background: #f0f0f0; width: 85%; margin: auto; border: none; height: 2px" class="mt-4" />

					<v-row v-if="!showLocumSection">
						<v-col>
							<div>
								<v-btn class="v-btn v-btn--text theme--light v-size--default secondary--text" style="float: left" text @click="cancelLocumSearch()"
									><v-icon left large color="secondary">mdi-chevron-left</v-icon>Back</v-btn
								>
							</div>
						</v-col>
					</v-row>

					<div v-if="locumFromStore.booking" class="mt-4 pl-2">
						<div class="black-text font-weight-black" align="left">{{ hasLocum ? 'Booking' : 'Offer' }} Details:</div>
						<booking-details :booking="booking" />
					</div>

					<div v-if="locumFromStore.booking && viewSource !== 'viewPostedOffer'">
						<booking-cost-summary :locum="locumData" :booking="booking"></booking-cost-summary>
					</div>

					<v-row class="pb-3">
						<v-spacer />
						<v-col :cols="6" align="left" justify="left">
							<div v-if="viewSource === 'viewLocumApplication'">
								<v-btn
									style="position: relative"
									:class="[contrastOnAccent, 'button-rounded', 'mt-2']"
									:height="25"
									width="80%"
									color="accent"
									@click="openMessageDialog()"
								>
									<span style="font-size: 10px">Message</span>
									<v-badge
										class="badge-styling"
										:content="unreadMessageCount"
										:value="unreadMessageCount"
										color="primary"
										overlap
										top
										bordered
										offset-y="top"
										offset-x="right"
									></v-badge>
								</v-btn>
								<v-btn class="white--text button-rounded mt-2" :height="25" width="80%" color="#63C367" @click="doPracticeAcceptLocumApplication()"
									><span style="font-size: 10px">Accept Application</span></v-btn
								>
								<v-btn
									:class="[contrastOnPrimary, 'button-rounded', 'mt-2']"
									:height="25"
									width="80%"
									color="primary"
									@click="doPracticeDeclineLocumApplication()"
									><span style="font-size: 10px">Decline Application</span></v-btn
								>
							</div>
							<div v-if="['viewUpcomingBooking', 'viewBookingRequestSent'].includes(viewSource) && !isPastEvent" class="pr-2">
								<div v-if="!showCancel">
									<v-btn
										style="position: relative"
										class="white--text button-rounded mt-2"
										:height="25"
										width="100%"
										color="accent"
										@click="openMessageDialog()"
									>
										<span style="font-size: 10px">Message</span>
										<v-badge
											class="badge-styling"
											:content="unreadMessageCount"
											:value="unreadMessageCount"
											color="primary"
											overlap
											top
											bordered
											offset-y="top"
											offset-x="right"
										></v-badge>
									</v-btn>

									<v-btn
										v-if="['viewBookingRequestSent'].includes(viewSource)"
										class="white--text button-rounded mt-2"
										:height="25"
										width="100%"
										color="secondary"
										@click="editOffer()"
										><span style="font-size: 10px">Edit Booking {{ viewSource === 'viewBookingRequestSent' ? 'Request' : '' }}</span></v-btn
									>
									<v-btn class="white--text button-rounded mt-2" :height="25" width="100%" color="#f44336" @click="showCancel = true"
										><span style="font-size: 10px">Cancel Booking {{ viewSource === 'viewBookingRequestSent' ? 'Request' : '' }}</span></v-btn
									>
								</div>
								<div v-if="showCancel">
									<div>
										<p>
											<b>Cancellation Reason</b>
										</p>
										<v-textarea v-model="cancellationReason" style="font-size: 11px" auto-grow filled color="primary" rows="1"></v-textarea>
									</div>
									<v-btn
										class="white--text button-rounded"
										:height="25"
										color="primary"
										width="100%"
										:disabled="cancellationReason.length < 5"
										@click="cancelBooking"
										><span style="font-size: 10px">Submit Cancellation</span></v-btn
									>
									<v-btn class="white--text button-rounded mt-2" :height="25" color="#4d88a1 " width="100%" @click="showCancel = false"
										><span style="font-size: 10px">Nevermind</span></v-btn
									>
								</div>
							</div>
							<div v-if="viewSource === 'viewPostedOffer'">
								<v-btn :class="[contrastOnSecondary, 'button-rounded', 'mt-2']" :height="25" width="80%" color="secondary" @click="editOffer()"
									><span style="font-size: 10px">Edit this offer</span></v-btn
								>
								<v-btn class="white--text button-rounded mt-2" :height="25" width="80%" color="#f44336" @click="deletePublicOffer()"
									><span style="font-size: 10px">Cancel this offer</span></v-btn
								>
							</div>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
		</v-row>
	</div>
	<PracticeEditBookingDialog ref="practiceEditBooking" :booking="booking" @bookigUpdate="updateBookingDetails"></PracticeEditBookingDialog>
</div>
